import { getTvObject, tv } from '@costar-ui/cosmos';

var variant = getTvObject({
  neutral: ['bg-neutral-subtlest', 'text-on-neutral-subtlest', 'border-neutral'],
  alert: ['bg-status-negative-subtle', 'border-status-negative', 'text-status-negative'],
  accent: ['bg-accent-highlight-contrast', 'border-accent-emphasize', 'text-on-accent-highlight-contrast'],
  notify: ['bg-accent-highlight-notify', 'border-transparent', 'text-on-accent-highlight-positive']
});
var tagInnerTV = getTvObject({
  base: ['flex', 'max-w-fit', 'cursor-default', 'items-center', 'gap-1', 'rounded-full', 'px-2', 'transition', 'border', 'overflow-hidden', 'text-p-14', 'h-6'],
  variants: {
    variant: variant
  }
});
var base = tv(tagInnerTV);
var tagInnerStyles = {
  base: base
};

export { tagInnerStyles, tagInnerTV };
//# sourceMappingURL=tag-inner.styles.esm.js.map
